<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"/>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">结算订单详情</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <div class="flex-1 flex-div">
          <div class="detail-mes-div flex">
            <div class="detail-title-div">分成订单号：</div>
            <div>{{ receiveOrder.pileOrderReceiveAccountSplitId }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">结算单号：</div>
            <div>{{ receiveOrder.payoutRecordId }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">结算状态：</div>
            <div>{{ receiveOrder.settlementStatus }}</div>
          </div>
        </div>
        <div class="flex-title">相关充电订单详情</div>
        <div class="flex-1 flex-div">
          <div class="detail-mes-div flex">
            <div class="detail-title-div">订单号：</div>
            <div>{{ receiveOrder.orderNo }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">手机号：</div>
            <div>{{ receiveOrder.custPhone }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">订单状态：</div>
            <div>{{ receiveOrder.settlementStatus }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">支付状态：</div>
            <div>{{ '已支付' }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">相关站点：</div>
            <div>{{ receiveOrder.stationName }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">所属运营商：</div>
            <div>{{ receiveOrder.dealName }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">交易类型：</div>
            <div>{{ receiveOrder.orderType }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">支付方式：</div>
            <div>{{ receiveOrder.payType }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">开始时间：</div>
            <div>{{ receiveOrder.beginTime }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">结束时间：</div>
            <div>{{ receiveOrder.endTime }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">充电度数：</div>
            <div>{{ receiveOrder.chargeVal }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">订单金额：</div>
            <div>{{ receiveOrder.tActFee }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">电费折扣：</div>
            <div>{{  }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">服务费折扣：</div>
            <div>{{  }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">减免电费：</div>
            <div>{{ receiveOrder.reduceElecFee }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">减免服务费：</div>
            <div>{{ receiveOrder.reduceServFee }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">结算电费：</div>
            <div>{{ receiveOrder.actElecFee }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">结算服务费：</div>
            <div>{{ receiveOrder.servFee }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">结算金额：</div>
            <div>{{ receiveOrder.settleFee }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">总分成费用：</div>
            <div>{{ receiveOrder.orderTotalSplitAmount }}</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">钱包余额支付：</div>
            <div>
              {{ receiveOrder.deductionFee }} 元（剩余可退：{{ "0" }} 元）
            </div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">度电支付：</div>
            <div>
              {{ receiveOrder.deductionElec }} 度（剩余可退：{{ "0" }} 度）
            </div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">实际在线支付：</div>
            <div>{{ receiveOrder.onlinePayFee }} 元（{{ "支付宝" }} ）</div>
          </div>
          <div class="detail-mes-div flex">
            <div class="detail-title-div">已退金额：</div>
            <div>
              {{ receiveOrder.refundAmount }} 元（剩余可退：{{ "0" }} 元）
            </div>
          </div>
        </div>
        <div v-for="(item, index) in receiveAccountSplit" :key="index">
          <div class="flex-title">分成订单相关商户{{receiveAccountSplit.length === 1 ? '' : index + 1}}</div>
          <div class="flex-1 flex-div">
            <div class="detail-mes-div flex">
              <div class="detail-title-div">清分账户：</div>
              <div>{{ item.receiveAccountName }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">开户行：</div>
              <div>{{ item.receiveAccountLocatedBankNo }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">分成银行卡号：</div>
              <div>{{ item.receiveBankCardNo }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">账户名：</div>
              <div>{{ item.shareholderName }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">分成方式：</div>
              <div>{{ item.splitTypeName }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">分成比例：</div>
              <div>{{ item.splitTypeValueString }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">分成周期：</div>
              <div>{{ item.dividedCyclesName }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">提现周期：</div>
              <div>{{ item.payoutCyclesName }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">分成时间：</div>
              <div>{{ item.splitDatetime }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">提现时间：</div>
              <div>{{ item.payoutDatetime }}&nbsp;&nbsp;</div>
            </div>
            <div class="detail-mes-div flex">
              <div class="detail-title-div">本单分成金额：</div>
              <div>{{ item.orderTotalSplitAmount }}&nbsp;&nbsp;元</div>
            </div>
          </div>
        </div>
        <div class="flex-title">相关金流</div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="操作时间" prop="operationTime" width="240"/>
          <el-table-column label="操作人" prop="operatorName" width="160"/>
          <el-table-column label="操作类型" prop="operationName" width="140"/>
          <el-table-column label="订单金流" prop="operationDesc"/>
        </el-table>
      </div>
      <div class="detail-content-footer-div">
        <!--
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        -->
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
  import pageConfig from "./page-config";
  
  export default {
    name: "summaryTableDetail",
    data() {
      return {
        pageConfig: pageConfig, // 页面配置
        pagination: pageConfig.pagination,
        receiveOrder: {}, // 相关充电订单详情
        receiveAccountSplit: {}, // 订单相关商户
        tableData: [], // 表格数据
      };
    },
    methods: {
      //初始化数据内容
      init() {
        let _ = this;
        let params = {
          pileOrderReceiveAccountSplitId: _.$route.query.pileOrderReceiveAccountSplitId,
        }
        _.$H.post(_, _.$A.cleanSettleRecord.getPayOrderTableDetail, params).then((res) => {
          _.tableData = res.data.data.logList || [];
          _.receiveAccountSplit = res.data.data.splitList || [];
        })
      },
      // 取消
      resetForm() {
        this.$router.push({
          name: "summaryDetail",
        });
      },
    },
    
    mounted() {
      this.init();
      this.receiveOrder = this.$store.state.receiveOrder;
    },
  };
</script>

<style lang="less" scoped>
  .detail-mes-div {
    height: 35px;
    line-height: 35px;
    padding: 10px;
    margin-bottom: 10px;
    font-size: 14px;
  }
  
  .detail-title-div {
    width: 100px;
    text-align: right;
    margin-right: 50px;
  }
  
  .detail-btn {
    height: 32px;
    margin-left: 45px;
  }
  
  .margin-rt-20 {
    margin-right: 20px;
  }
  
  .dialog-title-div {
    margin: 15px 0px;
  }
  
  .flex-div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    
    .detail-mes-div {
      width: calc(100% / 3);
    }
  }
  
  .flex-title {
    width: 100%;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    margin: 16px 0;
  }
</style>
